import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=58a77344&scoped=true&"
import script from "./VideoPlayer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VideoPlayer.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=58a77344&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a77344",
  null
  
)

export default component.exports